import { EMPTY_STRING } from 'constants/i18n';

const offsetsConfig = {
  mobile: {
    beginBase: 1,
    endBaseOffset: 1,
    lastEndBase: 0.9,
    laseBeginOffset: 0.1,
  },
  desktop: {
    beginBase: 0.4,
    endBaseOffset: 0.6,
    lastEndBase: 1.2,
    laseBeginOffset: 0.1,
  },
};

const getGroupStatusBeginInitial = length => {
  const result = Array(length).fill(false);
  result[0] = true;
  return result;
};

const getAnimationGroupOffsets = (innerHeight, length, type) => {
  const animationGroupOffsets = [];
  const {
    beginBase,
    endBaseOffset,
    lastEndBase,
    laseBeginOffset,
  } = offsetsConfig[type];

  for (let index = 0; index < length; index += 1) {
    let offsets;

    if (index === length - 1) {
      const previousEnd =
        animationGroupOffsets[animationGroupOffsets.length - 1].end;
      const currentBegin = previousEnd - laseBeginOffset * innerHeight;
      offsets = {
        begin: currentBegin,
        end: currentBegin + lastEndBase * innerHeight,
      };
    } else {
      const base = beginBase * index;
      offsets = {
        begin: base * innerHeight,
        end: (base + endBaseOffset) * innerHeight,
      };
    }
    animationGroupOffsets.push(offsets);
  }

  return animationGroupOffsets;
};

const getElementVisibility = (status, imageUrl) => {
  return status && imageUrl !== EMPTY_STRING ? 'visible' : 'hidden';
};

export {
  getGroupStatusBeginInitial,
  getAnimationGroupOffsets,
  getElementVisibility,
};
